import { Helmet } from 'react-helmet-async';
import { Container, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { getVersion, updateVersion } from '../services/Common/version.service';

export default function VersionPage() {
    const [form, setForm] = useState({ version: '', url: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getVersion()
            .then((data) => {
                if (data) setForm({ version: data.version || '', url: data.url || '' });
            })
            .catch(() => toast('Failed to load version', { type: 'error' }));
    }, []);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            await updateVersion({ version: form.version, url: form.url });
            toast('Version updated successfully', { type: 'success' });
        } catch (err) {
            toast('Failed to update version', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title> App Version | Trooper </title>
            </Helmet>

            <Container>
                <Typography variant="h4" gutterBottom>
                    App Version
                </Typography>

                <Stack spacing={3} sx={{ maxWidth: 480, mt: 3 }}>
                    <TextField
                        label="Version"
                        value={form.version}
                        onChange={(e) => setForm({ ...form, version: e.target.value })}
                        placeholder="1.1.9"
                        fullWidth
                    />
                    <TextField
                        label="Store URL"
                        value={form.url}
                        onChange={(e) => setForm({ ...form, url: e.target.value })}
                        placeholder="https://play.google.com/store/apps/details?id=com.trooper.mth"
                        fullWidth
                    />
                    <LoadingButton
                        variant="contained"
                        size="large"
                        loading={loading}
                        onClick={handleSubmit}
                    >
                        Update Version
                    </LoadingButton>
                </Stack>
            </Container>
        </>
    );
}
